import { render } from "./TeamMember.vue?vue&type=template&id=a6aff664&scoped=true"
import script from "./TeamMember.vue?vue&type=script&lang=js"
export * from "./TeamMember.vue?vue&type=script&lang=js"

import "./TeamMember.vue?vue&type=style&index=0&id=a6aff664&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6aff664"]])

export default __exports__